import { gql } from '@apollo/client';

import { PRODUCT_GRID_FRAGMENT_LITE } from 'mocks/queries';

const ProductBasicDetailsFragment = gql`
  fragment ProductBasicDetailsFragment on Product {
    id
    sku
    slug
    name
    type {
      name
    }
    family {
      name
    }
    efg_flag
    exp_wood_product
    difficulty
    is_external
    category_ids
    clearance_stock(zipCode: $zipCode)
    attributes_min {
      dimensions
      urlKey
    }
    attributes {
      code
      label
      name
      value
    }
    additional_attributes {
      fet_left_img
      fet_right_img
      showpiece_desc
    }
    hero_images {
      sort_order
      img {
        url
        cropData
      }
      upholstery_name
      upholstery_type
    }
    variation_photos_count
    custom_properties {
      dimensional_image_desktop
      dimensional_image_mobile
      selling_attributes
      product_label
      intro_video_1x1
      intro_video_16x9
      ar_asset
      ar_asset_upholstery
      display_option_images
      default_angle
    }
    meta {
      id
      customer {
        favorited
        favOptions {
          optionName
          optionId
          optionType
        }
      }
      price(stateCode: $stateCode, regionId: $regionId) {
        discount_percent
        final_price
        original_price
        max_discount_percent
      }
      reviews {
        average_score
        count
        sample_reviews {
          title
          comment
          rate
          date
          full_name
        }
      }
      promotion {
        discount
        endDate
        startDate
        tiers {
          min_cart
          discount
        }
      }
      similar_products {
        id
      }
      collectionSlug
      eligible_protection_planids
    }
    customer_photos_min {
      photos {
        id
        url
      }
      totalPhotos
    }
    customer_reviews {
      reviews {
        id
        title
        comment
        date
        full_name
        location
        rate
      }
      totalReviews
      averageRating
    }
    layout_widgets {
      widget_identifier
      fields
    }
  }
`;

export const GET_MODULAR_SOFA_BUNDLE = gql`
  query getModularSofaBundle(
    $slug: String
    $zipCode: String
    $stateCode: String
    $regionId: String
  ) {
    modularBundle: getModularSofaBundle(slug: $slug) {
      modular_parent {
        ...ProductBasicDetailsFragment
      }
      products {
        sku
        difficulty
        variation_photos
        hero_images {
          sort_order
          img {
            url
            cropData
          }
          upholstery_name
          upholstery_type
        }
        family {
          name
        }
        ...ProductGridFragmentLite
      }
      preConfiguredProducts {
        hero_images {
          sort_order
          img {
            url
            cropData
          }
          upholstery_name
          upholstery_type
        }
        customer_photos_min {
          photos {
            id
            url
            full_name
            comment
          }
          totalPhotos
        }
        customer_reviews {
          reviews {
            id
            title
            comment
            date
            full_name
            location
            rate
          }
          totalReviews
          averageRating
        }
        ...ProductGridFragmentLite
      }
      totalProductsCount
    }
  }
  ${ProductBasicDetailsFragment}
  ${PRODUCT_GRID_FRAGMENT_LITE}
`;
